export default function getRouteNameAfterPasswordReset(layout) {
  if (layout === "admin") {
    // The admin layout has no dedicated sign-in route; its home (contacts)
    // renders the sign-in page (UNI login) while signed out.
    return "contacts"
  } else if (layout === "competition") {
    return "competitions"
  }

  return "newUserSession"
}
